import { Icon, Text } from "@zapier/design-system";

import commonStyles from "../AIStreamCreateModal.module.css";
import { Placeholder } from "../Placeholder";

import styles from "./TablesLoader.module.css";
import classNames from "classnames";

export function TablesLoader({
  zsl,
  isLoading,
  isShown,
}: {
  zsl: any;
  isLoading: boolean;
  isShown: boolean;
}) {
  const table = zsl.tablesPrompts?.tables?.[0];

  const column1 = table?.fields?.[0]?.name;
  const column2 = table?.fields?.[1]?.name;
  const column3 = table?.fields?.[2]?.name;

  return (
    <div
      className={classNames(commonStyles.loadingCard, styles.tableLoadingCard, {
        [commonStyles.loadingCardLoading]:
          isLoading && !zsl.tables && !zsl.tablePrompts,
        [commonStyles.shown]: isShown,
      })}
    >
      <div className={commonStyles.cardHeader}>
        <Icon name="navTables" color="BrandOrange" size={16} />
        <p className={commonStyles.title}>Tables</p>
        {!isLoading && (
          <p className={commonStyles.subtitle}>
            Databases designed for systems
          </p>
        )}
      </div>
      <div className={styles.table}>
        <div className={styles.tableRow}>
          <div className={styles.tableCell}>
            <Icon name="formBlank" size={18} color="GrayWarm5" />
          </div>
          <div className={styles.tableCell}>
            {!column1 && <Placeholder width={48} />}
            {column1 && <Text type="MinimalPrint3">{column1}</Text>}
          </div>
          <div className={styles.tableCell}>
            {!column2 && <Placeholder width={64} />}
            {column2 && <Text type="MinimalPrint3">{column2}</Text>}
          </div>
          <div className={styles.tableCell}>
            {!column3 && <Placeholder width={48} />}
            {column3 && <Text type="MinimalPrint3">{column3}</Text>}
          </div>
        </div>
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className={styles.tableRow}>
            <div className={styles.tableCell}>
              <Icon name="formBlank" size={18} color="GrayWarm5" />
            </div>
            <div className={styles.tableCell}>
              <Placeholder width={48} />
            </div>
            <div className={styles.tableCell}>
              <Placeholder width={64} />
            </div>
            <div className={styles.tableCell}>
              <Placeholder width={48} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
